module.exports = __webpack_public_path__ + "assets/img/mecha-7df47e7e.png";